<div class="search-container">
  <div class="search-bar">
    <div class="search-button">
      <button mat-raised-button (click)="animesSearch()">Search</button>
    </div>
    <div class="search">
      <input #searchInput className="search-bar" placeholder="Please enter anime name" (change)="searchChange($event)"
        (keydown.enter)="onEnterSearch($event)" value="">
    </div>
  </div>

  <div class="anime-grid mat-elevation-z8">

    <div *ngIf="searchTerm === null" class="empty-search-container">
      <div class="search-notice">
        <i class="material-icons search-icon">search</i>
        <p class="search-text">Please Enter Anime Name In the Search Bar</p>

      </div>
    </div>

    <div *ngIf="isLoading" class="table-loading-container">
      <div class="loading-spinner">
        <app-loading></app-loading>
      </div>
    </div>

    <div *ngIf="!isLoading && searchTerm !== null" class="anime-table-container">

      <table mat-table [dataSource]="dataSource" class="anime-table" matSort matSortActive="created" matSortDisableClear
        matSortDirection="desc">
        <!-- Number Column -->
        <ng-container matColumnDef="cover">
          <th class="grid-header-column" mat-header-cell *matHeaderCellDef></th>
          <td class="anime-cover" mat-cell *matCellDef="let row"><img class="card-img-top" id="poster-img" alt="poster"
              [routerLink]="['/animeSearch', row.id]" src={{row.coverImage.large}}></td>
        </ng-container>

        <!-- Title Column -->
        <ng-container matColumnDef="desc">
          <th class="grid-header-column desc" mat-header-cell *matHeaderCellDef>Description</th>
          <td class="anime-desc" mat-cell *matCellDef="let row">
            <div class="anime-desc-container">
              <div class="card-title">
                <a [routerLink]="['/animeSearch', row.id]">
                  <h2 class="main-title">{{row.title.english}}</h2>
                </a>
                <a [routerLink]="['/animeSearch', row.id]">
                  <p>{{row.title.romaji}}</p>
                </a>

              </div>
              <div class="card-summary">
                <p class="summary">{{row.description}}</p>
                <p class="type">Type: {{row.type}}</p>
                <p class="tags">Tags: {{row.genres}}</p>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- State Column -->
        <ng-container matColumnDef="rating">
          <th class="grid-header-column rating" mat-header-cell *matHeaderCellDef>Rating</th>
          <td class="anime-rating" mat-cell *matCellDef="let row">{{getRating(row.avgScore)}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <mat-paginator [ngClass]="{ hiddenElement: !(!isLoading && searchTerm !== null) }" [showFirstLastButtons]="true"
      [pageSizeOptions]="[10, 20, 30, 40, 50]" [length]="resultsLength"
      aria-label="Select page of GitHub search results">
    </mat-paginator>
  </div>